<script lang="ts" setup>
import imageHomeDesktop1 from '@/assets/image/home/desktop1.png'
import imageHomeDesktop2 from '@/assets/image/home/desktop2.png'
import imageHomeDesktop31 from '@/assets/image/home/desktop3-1.png'
import imageHomeDesktop32 from '@/assets/image/home/desktop3-2.jpg'
import imageHomeDesktop33 from '@/assets/image/home/desktop3-3.png'
import imageHomeDesktop4 from '@/assets/image/home/desktop4.png'

const { setDefaultMeta } = usePageHeadMetaData()

definePageMeta({
  name: PAGE_NAME.HOME,
  key: (route) => route.fullPath,
  layout: 'home',
})

setDefaultMeta()

const handleClickApply = () => {
  navigateTo(URL_MAP.ARTIST)
}
</script>

<template>
  <div class="HomeDesktop">
    <ClientOnly>
      <div class="HomeDesktop__title">
        <div class="HomeDesktop__titleText">
          <p class="HomeDesktop__titleTextLine">'창작과 정성의 가치'가</p>
          <p class="HomeDesktop__titleTextLine">인정받는 세상을 만듭니다</p>
        </div>
        <div class="HomeDesktop__titleYoutube">
          <iframe
            frameborder="0"
            allowfullscreen
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            referrerpolicy="strict-origin-when-cross-origin"
            title="idus"
            width="100vw"
            height="100vh"
            :src="RESOURCE.HOME_LINK.YOUTUBE"
          ></iframe>
        </div>
      </div>
      <BaseImageMap :src="imageHomeDesktop1" :map-name="'#home1'">
        <map name="home1">
          <area
            target="_blank"
            alt=""
            title=""
            :href="RESOURCE.HOME_LINK.ARTIST_STORY"
            coords="159,858,484,929"
            shape="rect"
          />
          <area
            target="_blank"
            alt=""
            title=""
            :href="RESOURCE.HOME_LINK.ARTIST_AND_CUSTOMER"
            coords="1192,1910,1656,1973"
            shape="rect"
          />
          <area
            target="_blank"
            alt=""
            title=""
            :href="RESOURCE.HOME_LINK.IDUS_GLOBAL"
            coords="155,2887,355,2943"
            shape="rect"
          />
        </map>
      </BaseImageMap>
      <BaseImageMap :src="imageHomeDesktop2" :map-name="'#home2'">
        <map name="home2">
          <area
            target="_blank"
            alt=""
            title=""
            :href="RESOURCE.HOME_LINK.TUMBLBUG"
            coords="569,1572,795,1623"
            shape="rect"
          />
          <area
            target="_blank"
            alt=""
            title=""
            :href="RESOURCE.HOME_LINK.IDUS"
            coords="1652,1572,1867,1623"
            shape="rect"
          />
        </map>
      </BaseImageMap>
      <img :src="imageHomeDesktop31" />
      <img :src="imageHomeDesktop32" />
      <img :src="imageHomeDesktop33" />
      <img :src="imageHomeDesktop4" />
      <div class="HomeDesktop__applyButton">
        <BaseButtonRectanglePrimary
          :title="RESOURCE.ARTIST_APPLY_BUTTON_TEXT"
          :size="'xx_large'"
          :blocked="true"
          @click="handleClickApply"
        />
      </div>
    </ClientOnly>
  </div>
</template>

<style lang="scss" scoped>
area {
  @apply cursor-pointer;
}

.HomeDesktop {
  &__title {
    @apply flex justify-center items-center;
    @apply relative;
    @apply overflow-hidden;
    @apply aspect-video;
    @apply w-full;

    // height: calc(100vh - var(--layout-header-height));

    &Youtube {
      @apply absolute top-[50%] left-[50%];
      @apply opacity-[0.8];
      @apply overflow-hidden;
      @apply h-full w-full;
      @apply aspect-video;

      transform: translate(-50%, -50%);
      pointer-events: none;

      iframe {
        width: 300%;
        height: 100%;
        margin-left: -100%;
      }
    }

    &Text {
      @apply text-center headline3_bold_small;
      @apply z-[1];

      color: var(--ids-color-white);

      &Line {
        @apply mb-[10px] last:mb-0;
      }
    }
  }

  &__applyButton {
    @apply sticky bottom-0 left-0;
    @apply px-[16px] py-[8px];

    background-color: var(--ids-color-white);
  }
}
</style>
